import Badge from '@pelckmans/elementis/components/badge';
import Pill from '@pelckmans/elementis/components/pill';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import type { Module } from '../../../../api/module';
import IdentityContext from '../../../../contexts/IdentityContext';
import DigibookContext from '../../_contexts/DigibookContext';

const BASE = 'PAGES.SUBMODULE_SELECTOR.TAGS';

export default function ModuleCardTags({
  module,
  sharedUserMaterialCount = 0,
  sharedSlideSetCount = 0,
}: {
  module: Module;
  sharedUserMaterialCount?: number;
  sharedSlideSetCount?: number;
}) {
  const { getDigibookAppForModule } = useContext(DigibookContext);
  const { identity } = useContext(IdentityContext);
  const { t } = useTranslation();

  const digibook = getDigibookAppForModule(module.id);

  const {
    slideSets = 0,
    studentExercises,
    teacherExercises,
    studentOtherMaterials,
    teacherOtherMaterials,
  } = module.counts;

  return (
    <>
      {digibook &&
        (digibook.linkedApp?.manualIncluded && identity.isTeacherAlike ? (
          <Pill>{t(`${BASE}.DIGIBOOK_WITH_MANUAL`)}</Pill>
        ) : (
          <Pill>{t(`${BASE}.DIGIBOOK`)}</Pill>
        ))}
      {identity.isTeacherAlike ? (
        <>
          {slideSets > 0 && <Pill badge={<Badge>{slideSets}</Badge>}>{t(`${BASE}.SLIDE_SETS`)}</Pill>}
          {teacherExercises > 0 && <Pill badge={<Badge>{teacherExercises}</Badge>}>{t(`${BASE}.EXERCISES`)}</Pill>}
          {teacherOtherMaterials > 0 && (
            <Pill badge={<Badge>{teacherOtherMaterials}</Badge>}>{t(`${BASE}.OTHER_MATERIAL`)}</Pill>
          )}
        </>
      ) : (
        <>
          {sharedSlideSetCount > 0 && (
            <Pill badge={<Badge>{sharedSlideSetCount}</Badge>}>{t(`${BASE}.SHARED_SLIDE_SET`)}</Pill>
          )}
          {studentExercises > 0 && <Pill badge={<Badge>{studentExercises}</Badge>}>{t(`${BASE}.EXERCISES`)}</Pill>}
          {studentOtherMaterials > 0 && (
            <Pill badge={<Badge>{studentOtherMaterials}</Badge>}>{t(`${BASE}.OTHER_MATERIAL`)}</Pill>
          )}
          {sharedUserMaterialCount > 0 && (
            <Pill badge={<Badge>{sharedUserMaterialCount}</Badge>}>{t(`${BASE}.SHARED_USER_MATERIAL`)}</Pill>
          )}
        </>
      )}
    </>
  );
}
